///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';

export class GtthRequestLockProjectCommand extends GtthAbstractCommand {
    private showError: boolean;

    getCommandName(): string {
        return 'GtthRequestLockProjectCommand';
    }

    create(showError: boolean): this {
        this.showError = showError;
        return this;
    }

    doCommand(): void {
        const activity = this.createActivityDTO(true);
        this.sendActivity(activity);
    }

    doCommandActivity(activityDTO: ActivityDTO): void {
        if (this.commandResolve) {
            this.historyService.canCommandLockProject = true;
            this.commandResolve(activityDTO.successful);
        } else {
            this.historyService.canCommandLockProject = false;
        }
    }
}
